import ProGallery_DefaultComponent from '../components/ProGallery/viewer/skinComps/Default/Default.skin';


const ProGallery_Default = {
  component: ProGallery_DefaultComponent
};


export const components = {
  ['ProGallery_Default']: ProGallery_Default
};

